export interface ICis {
  // PCP / practice
  tin?: string | null;
  plan?: string | null;
  practice_name?: string | null;
  npi?: string | null;
  pcp_name?: string | null;
  pcp_address?: string | null;
  pcp_city?: string | null;
  pcp_state?: string | null;
  pcp_zip?: string | null;

  // Measure
  measure_code?: string | null;
  measure_description?: string | null;
  denominator?: string | null;
  numerator?: string | null;
  line_of_business?: string | null;

  // Member
  plan_member_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  date_of_birth?: string | null;
  language?: string | null;
  race_ethnicity?: string | null;
  gender?: string | null;
  member_address?: string | null;
  member_city?: string | null;
  member_state?: string | null;
  member_zip?: string | null;
  member_phone?: string | null;
  member_emr_phone_number?: string | null;
  member_2nd_birthday?: string | null;

  // CIS antigens
  cis_dtap_a_4?: string | null;
  cis_polio_a_3?: string | null;
  cis_mmr_1?: string | null;
  cis_hib_a_3?: string | null;
  cis_hepb_a_3?: string | null;
  cis_vzv_1?: string | null;
  cis_pcv_a_4?: string | null;
  cis_hepa_1?: string | null;
  cis_rotavirus_a_3?: string | null;
  cis_influenza_a_2?: string | null;

  // Reporting / metadata
  daterun?: string | null;
  filename?: string | null;
  added_tz?: string | null;
  file_date?: string | null;
  services_outstanding?: string | null;
  somos_member_id?: string | null;
  somos_provider_id?: string | null;
  service_location_id?: string | null;
  reporting_period?: string | null;
  owner_id?: number | null;
}

export class Cis implements ICis {
  tin?: string | null;
  plan?: string | null;
  practice_name?: string | null;
  npi?: string | null;
  pcp_name?: string | null;
  pcp_address?: string | null;
  pcp_city?: string | null;
  pcp_state?: string | null;
  pcp_zip?: string | null;

  measure_code?: string | null;
  measure_description?: string | null;
  denominator?: string | null;
  numerator?: string | null;
  line_of_business?: string | null;

  plan_member_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  date_of_birth?: string | null;
  language?: string | null;
  race_ethnicity?: string | null;
  gender?: string | null;
  member_address?: string | null;
  member_city?: string | null;
  member_state?: string | null;
  member_zip?: string | null;
  member_phone?: string | null;
  member_emr_phone_number?: string | null;
  member_2nd_birthday?: string | null;

  cis_dtap_a_4?: string | null;
  cis_polio_a_3?: string | null;
  cis_mmr_1?: string | null;
  cis_hib_a_3?: string | null;
  cis_hepb_a_3?: string | null;
  cis_vzv_1?: string | null;
  cis_pcv_a_4?: string | null;
  cis_hepa_1?: string | null;
  cis_rotavirus_a_3?: string | null;
  cis_influenza_a_2?: string | null;

  daterun?: string | null;
  filename?: string | null;
  added_tz?: string | null;
  file_date?: string | null;
  services_outstanding?: string | null;
  somos_member_id?: string | null;
  somos_provider_id?: string | null;
  service_location_id?: string | null;
  reporting_period?: string | null;
  owner_id?: number | null;

  constructor(data: ICis) {
    Object.assign(this, data);
  }

  static fromObject(data: ICis): Cis {
    return new Cis(data);
  }

  static fromObjectArray(data: ICis[]): Cis[] {
    return data.map(Cis.fromObject);
  }
}

export interface IResultCis {
  count: number;
  next: string | null;
  previous: string | null;
  results: ICis[];
}

export class ResultCis implements IResultCis {
  count: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: Cis[] = [];

  constructor(data?: IResultCis) {
    if (data) {
      this.count = data.count;
      this.next = data.next;
      this.previous = data.previous;
      this.results = data.results ? Cis.fromObjectArray(data.results) : [];
    }
  }

  static fromObject(data: IResultCis): ResultCis {
    return new ResultCis(data);
  }
}
